import '@axmit/garwin-api';
import { IRequestSuccess } from 'common/models';
import { IUser } from 'entities/User/User.models';

export enum EClientType {
  Web = 'web',
}

export interface ISessionMeta {
  clientType: EClientType;
  deviceId: string;
}

export interface IAuthLoginPayload extends Components.Schemas.LoginRequest, IRequestSuccess {}
export interface IAuth extends Components.Schemas.LoginResponse {}
export interface IAuthSendOtpPayload extends Components.Schemas.SendEmailOtpDto, IRequestSuccess {}
export interface IAuthVerifyOtpPayload extends Components.Schemas.VerifyEmailOtpDto, IRequestSuccess {}
export interface IAuthSendPhoneOtpPayload extends Components.Schemas.SendPhoneOtpDto, IRequestSuccess {}
export interface IAuthVerifyPhoneOtpPayload extends Components.Schemas.VerifyPhoneOtpDto, IRequestSuccess {}
export interface IRestorePasswordEmailPayload extends Components.Schemas.SendRestorePasswordEmailDto, IRequestSuccess {}
export interface IRestorePasswordPayload extends Components.Schemas.RestorePasswordDto, IRequestSuccess {}
export interface IPermissions extends Components.Schemas.PermissionsDto {}

export interface IToken {
  access: {
    id: number;
    token: string;
    userId: number;
    issuedAt: number;
    expiredAt: number;
    accountId?: number;
    accountName?: string;
    firstName?: string;
    lastName?: string;
    patronymic?: string;
    roles: string[];
    isSeller: boolean;
    isSelfRegistered: boolean;
    selfRegistrationCompletedAt?: string;
    selfRegistrationStep?: string;
    basketId?: number;
    permissions: IPermissions;
  };
  refresh: {
    id: number;
    token: string;
    userId: number;
    issuedAt: number;
    expiredAt: number;
  };
}

export interface IAuthState {
  data: IToken | null;
  loading: boolean;
  error: string | null;
  xUserId: number | null;
  xBasketId: number | null;
  userCatalogId: number | null;
}

export interface ILoginAsUserPayload {
  user: IUser;
  isSeller: boolean;
}

export const refreshTokenExpiration = 30 * 86400; // = 30 days
